import './login.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import * as actions from '../login/actions';
import UserIcon from 'images/user-icon.svg';
import { trackNow } from 'shared/models/analytic';
import { activeOrder } from 'shared/models/user';
import AuthModal from '../login/modal';
import Dropdown from 'components/ui/dropdown';
import TrackIcon from 'images/track.gif';
import AccountIcon from 'images/icons/account.svg';
import HistoryIcon from 'images/icons/time-outline-cropped.svg';
import HelpIcon from 'images/icons/help.svg';
import MailIcon from 'images/icons/mail.svg';

class LoginComponent extends React.Component {
  componentDidUpdate(prevProps) {
    const prevUser = prevProps.user || {};
    const nextUser = this.props.user || {};
    if (nextUser.objectId && nextUser.objectId !== prevUser.objectId) {
      this.props.loadLoggedInUser();
    }
  }

  openDropDown(type) {
    this.props.showLogin(type);
    trackNow('Nav Login Button');
  }

  photo() {
    if (!this.props.user.fbID) return UserIcon;
    return `https://graph.facebook.com/${this.props.user
      .fbID}/picture?width=50&height=50&return_ssl_resources=1`;
  }

  render() {
    const currentOrder = activeOrder(this.props.user);
    const orders = (this.props.user && this.props.user.orders) || [];

    return (
      <Fragment>
        {!this.props.user ? (
          <div className="login-comp">
            <button
              className="btn--inline btn-small"
              onClick={this.openDropDown.bind(this, 'login')}
            >
              Log In
            </button>
            <button
              className="button login-button"
              onClick={this.openDropDown.bind(this, 'signup')}
            >
              Sign Up
            </button>
          </div>
        ) : (
          <div className="login-comp">
            {!!currentOrder && (
              <a href="/tracking" className="user-track">
                <img className="user-track-icon" src={TrackIcon} />
              </a>
            )}
            <Dropdown className="inline-block">
              {({ isOpen, triggerRef, contentRef }) => (
                <Fragment>
                  <button className="user-button" ref={triggerRef}>
                    <div id="avatar-container">
                      <img src={this.photo()} />
                    </div>
                    <span className="user-name">
                      Hi, {this.props.user.firstname}
                      <i className="icon-down-arrow" />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="menu-dropdown" ref={contentRef}>
                      <div className="menu-dropdown__section">
                        <div className="menu-dropdown__row">
                          <a href="/share">
                            <img
                              className="menu-dropdown__icon"
                              src={MailIcon}
                            />
                            Invite Friends
                          </a>
                        </div>
                        <div className="menu-dropdown__row">
                          <a href="/account">
                            <img
                              className="menu-dropdown__icon"
                              src={AccountIcon}
                            />
                            Your Account
                          </a>
                        </div>
                        {!!orders.length && (
                          <div className="menu-dropdown__row">
                            <a href="/orders">
                              <img
                                className="menu-dropdown__icon"
                                src={HistoryIcon}
                              />
                              Your Orders
                            </a>
                          </div>
                        )}
                        <div className="menu-dropdown__row">
                          <a
                            target="_blank"
                            rel="noreferrer noopener"
                            href="http://help.sauceyapp.com/"
                          >
                            <img
                              className="menu-dropdown__icon"
                              src={HelpIcon}
                            />
                            FAQs
                          </a>
                        </div>
                      </div>
                      <div className="menu-dropdown__section">
                        <div className="menu-dropdown__row">
                          <button
                            className="menu-dropdown__btn"
                            onClick={this.props.logout.bind(this)}
                          >
                            Logout
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </Fragment>
              )}
            </Dropdown>
          </div>
        )}
        <AuthModal />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { ...state.login };
}

export default connect(mapStateToProps, { ...actions })(LoginComponent);



// WEBPACK FOOTER //
// ./shared/components/header/login.js